module.exports = __webpack_public_path__ + "static/media/Valtice.75924083.md";